module.exports = __webpack_public_path__ + "img/index_not.dfa3e86c.png";